export default {
  setBreadcrumbs: ({ commit }: any, list: any) => {
    commit('SET_BREADCRUMBS', list)
  }
}
